import { ThemedText } from "@/components/themed-text";
import { BrandButton } from "@/components/ui/brand-button";
import { useAuth } from "@/contexts/auth-context";
import Ionicons from "@react-native-vector-icons/ionicons";
import { useRouter } from "expo-router";
import React from "react";
import { StyleSheet, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export default function CheckoutCancelScreen() {
  const router = useRouter();
  const { theme } = useAuth();

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.background }]}
    >
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Ionicons name="close-circle" size={80} color="#ef4444" />
        </View>
        <ThemedText type="title" style={styles.title}>
          Payment Cancelled
        </ThemedText>
        <ThemedText type="default" style={styles.message}>
          Your payment was not completed. You can return to your quote and try
          again when you are ready.
        </ThemedText>
        <BrandButton onPress={() => router.push("/quote")}>
          Back to Quote
        </BrandButton>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    gap: 16,
  },
  iconContainer: {
    marginBottom: 8,
  },
  title: {
    textAlign: "center",
  },
  message: {
    textAlign: "center",
    color: "#94a3b8",
    lineHeight: 24,
  },
});
